import { Toast } from 'cube-ui'
import CacheModel from '@/model/cacheModel'

class CacheControl {

  constructor(chatControl) {
    this.cacheModel = new CacheModel(chatControl.chatModel, {
      dayLimit: 3,
      hasSystemTip: false
    })
    this.init()
  }

  init() {
    pushHistory()
    window.addEventListener('popstate', (e) => {
      Toast.$create({
        txt: '是否确认退出此应用',
        type: 'warn'
      }).show()
      this.add()
    }, false)

    function pushHistory() {
      var state = {
        title: 'title',
        url: '#'
      }
      window.history.pushState(state, 'title', '#')
    }

    window.addEventListener('pagehide', this.add.bind(this), false)
    window.addEventListener('beforeunload', this.add.bind(this), false)
  }

  add() {
    this.cacheModel.add()
  }

  remove() {
    this.cacheModel.remove()
  }
}

export default CacheControl



// WEBPACK FOOTER //
// ./src/controller/modules/cacheControl.js